module.exports = __webpack_public_path__ + "img/mobile-app.203ffe16.png";